import cx from 'classnames';
import { ADD_NEXT_PHOTO } from 'mk/autogenerated/translations/PhotosUpload.112a5b5e4818d6a76da8bcc50f37c461'
import { upperCaseFirst } from 'mk/bazaar/common/filters';
import CoverPreview from 'mk2/containers/PhotosUpload/CoverPreview';
import PhotoPreview from 'mk2/containers/PhotosUpload/PhotoPreview';
import { photoUploadRemove, photoUploadRotate } from 'mk2/containers/PhotosUpload/PhotosUpload.actions';
import {
    FailedPhotoUpload,
    PendingPhotoUpload,
    PhotoUploadStatus,
    SuccessfulPhotoUpload,
} from 'mk2/helpers/form.reducers';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import { PhotoOrientation } from 'mk2/schemas';
import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import styles from './PhotosUpload.mscss';

export interface PhotosUploadConfig {
    photoType: string;
    multiple?: boolean;
    showPhotoCode: boolean;
    nameForCoverPreview?: string;
    photoUploadType?: PhotoUploadType;
    previewPhotoSize?: string;
    disableRotate?: boolean;
}

export interface UploadedPhoto {
    photoId: string;
    orientation: PhotoOrientation;
    status: PhotoUploadStatus;
}

export enum PhotoUploadType {
    REGULAR_PHOTOS,
    COVER_PHOTO,
    /* AVATAR_PHOTO */
}

interface OwnProps {
    formName: string;
    photoUploadType: PhotoUploadType;
    nameForCoverPreview?: string;
    showPhotoCode: boolean;
    disableRotate?: boolean;
    previewPhotoSize?: string;
    // funkcia, ktoru ma komponent vyvolat, ked chce otvori file dialog
    // (jej implementacia ma pristup k <input type="file"> elemetu a vie na nom zavolat click() funkciu)
    onClickUploadNextPhoto?();
}

interface StateProps {
    uploads: Array<PendingPhotoUpload | SuccessfulPhotoUpload | FailedPhotoUpload>;
}

interface DispatchProps {
    onRemovePhoto(formName: string, uploadId: number);
    onRotatePhoto(formName: string, uploadId: number, orientation: PhotoOrientation);
}

class PhotosUpload extends React.Component<OwnProps & StateProps & DispatchProps> {

    public render() {
        const {
            uploads, photoUploadType, nameForCoverPreview, previewPhotoSize, showPhotoCode, disableRotate,
            onClickUploadNextPhoto,
        } = this.props;
        const firstUpload = uploads && uploads.length > 0 ? uploads[0] : null;

        if (photoUploadType === PhotoUploadType.COVER_PHOTO && !firstUpload) {
            return null;
        }

        const failedUploads = uploads.filter((u) => (u.status === PhotoUploadStatus.FAILURE)) as FailedPhotoUpload[];
        return (
            <div className={cx(styles.PhotosUpload)}>
                {photoUploadType === PhotoUploadType.REGULAR_PHOTOS && uploads && (
                    <div className={cx('clearfix')}>
                        { uploads.map((upload) => {
                            return (
                                <PhotoPreview
                                    className={styles.PhotosUpload__photoBox}
                                    key={upload.id}
                                    upload={upload}
                                    onCancel={this.handleOnRemove}
                                    onRotate={disableRotate ? undefined : this.handleOnRotate}
                                    previewPhotoSize={previewPhotoSize}
                                    showPhotoCode={showPhotoCode}
                                />
                            );
                        })}
                        {onClickUploadNextPhoto && (
                            <div
                                className={cx(styles.PhotosUpload__photoBox, styles.PhotosUpload__addNew)}
                                onClick={onClickUploadNextPhoto}
                            >
                                <i className="fa fa-plus-circle fa-2x"/>
                                <span>{ADD_NEXT_PHOTO}</span>
                            </div>
                        )}
                    </div>
                )}
                {photoUploadType === PhotoUploadType.COVER_PHOTO && (
                    <CoverPreview
                        nameForCoverPreview={nameForCoverPreview}
                        key={uploads[0].id}
                        upload={uploads[0]}
                    />
                )}
                {failedUploads.length > 0 && (
                    <div
                        className={cx(styles.PhotosUpload__error)}
                    >
                        {failedUploads[0].errorMessage}
                    </div>
                )}
            </div>
        );
    }

    private handleOnRemove = (uploadId) => {
        const { formName, onRemovePhoto } = this.props;
        onRemovePhoto(formName, uploadId);
    };

    private handleOnRotate = (uploadId, orientation) => {
        const { formName, onRotatePhoto } = this.props;
        onRotatePhoto(formName, uploadId, orientation);
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { formName } = ownProps;
    const selector = formValueSelector(formName);
    return {
        uploads: selector(state, 'photos') as any[] || [],
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onRotatePhoto: photoUploadRotate,
    onRemovePhoto: photoUploadRemove,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhotosUpload);
